module.exports = __webpack_public_path__ + "static/img/text-intro-mobile-en.e1dcb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/wait/img/text-intro-mobile-en.png
// module id = pRAW
// module chunks = 1